import * as React from "react";
import { useQuery } from "@tanstack/react-query";
import type { ModalComponentProps } from "../../../types/modal.types";
import ConfirmModal from "../confirm.modal";
import { Box, Chip, FormControl, InputLabel, MenuItem, OutlinedInput, Select, type SelectChangeEvent } from "@mui/material";
import { useZoneGroup } from "../../../lib/apis/hooks/category.hook";
import { convertRegionData } from "../../../utils/zone.utils";
import type { ZoneItem } from "../../../lib/apis/dtos/response/store.response";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
  style: {
    zIndex: 3000
  }
};

interface ConvertedZone {
  zoneId: number;
  name: string;
}


interface AssignZoneModalProps extends ModalComponentProps {
  mainZoneId: number;
  subZones: ZoneItem[]
  onClick: (storeId: number[]) => void;
}

export default function AssignZoneModal(props: AssignZoneModalProps) {
  const { id, onClose, onClick, subZones, mainZoneId } = props;

  const [zones, setZones] = React.useState<string[]>(subZones.map((item) => `${item.region} ${item.zoneName}`));
  const [select, setSelect] = React.useState<number[]>(subZones.map((item) => item.zoneId));
  const [covertZone, setConvertZone] = React.useState<ConvertedZone[]>([]);

  const { data: zoneGroupData, isSuccess } = useQuery({
    ...useZoneGroup(),
  });

  const { result: zoneGroupResult } = zoneGroupData || {};

  const handleChange = (event: SelectChangeEvent<typeof zones>) => {
    const {
      target: { value },
    } = event;

    setZones(typeof value === "string" ? value.split(",") : value);
  };

  React.useEffect(() => {
    if (isSuccess) {
      setConvertZone(convertRegionData(zoneGroupResult?.zoneGroups || []))
    }
  }, [isSuccess])


  return (
    <ConfirmModal
      title="인근 영업 지역 변경"
      rightButton={{
        title: "저장",
        onClick: () => {
          onClose?.();
          onClick?.(select);
        },
      }}
      id={id}
      onClose={onClose}
    >
      <div className="py-4">
        <FormControl>
          <InputLabel id="demo-multiple-chip-label">인근 영업 지역 선택*</InputLabel>
          <Select
            labelId="demo-multiple-chip-label"
            id="demo-multiple-chip"
            className="w-[552px]"
            multiple
            value={zones}
            onChange={handleChange}
            input={<OutlinedInput id="select-multiple-chip" label="Chip" />}
            inputProps={{ "aria-label": "인근 영업 지역 선택*" }}
            renderValue={(selected) => (
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
                {selected.map((value, index) => (
                  <Chip
                    key={value}
                    onMouseDown={(e) => e.stopPropagation()}
                    label={value}
                    onDelete={() => {
                      setZones((prev) => prev.filter((_, i) => i !== index));
                      setSelect((prev) => prev.filter((_, i) => i !== index));
                    }}
                  />
                ))}
              </Box>
            )}
            MenuProps={MenuProps}
          >
            {isSuccess &&
              (covertZone || []).map(({ name, zoneId }, index) => {
                return (
                  <MenuItem
                    key={index}
                    disabled={zoneId === mainZoneId}
                    value={name}
                    onClick={() => {
                      let selected = [...select];
                      selected.push(zoneId);
                      setSelect(selected);
                    }}
                  >
                    {name}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </div>
    </ConfirmModal>
  )

}